export const profileReportsErgo = {
    namespaced: true,

    state: {
        filterFields: {},
        filter: {
            distanceId: [],
            timesId: [],
            hrIntensities: [],
            byErgoId: [],
            tags: [],
            focuses: []
        },
        tabsSelectPieceName: 0,
        selectedSessions: []
    },

    getters: {
        filterFields(state) {
            return state.filterFields;
        },

        getFilter(state) {
            return state.filter;
        },

        getTabsSelectPieceName(state) {
            return state.tabsSelectPieceName;
        },

        selectedSessions(state) {
            return state.selectedSessions;
        }
    },

    mutations: {
        resetState(state) {
            state.filterFields = {};
            state.filter = {
                distanceId: [],
                timesId: [],
                hrIntensities: [],
                byErgoId: [],
                tags: [],
                focuses: []
            };
            state.tabsSelectPieceName = 0;
            state.selectedSessions = [];
        },

        setFilterFields(state, payload) {
            state.filterFields = payload;
        },

        setTags(state, payload) {
            state.filter.tags = payload;
        },

        setTabsSelectPieceData(state, payload) {
            state.tabsSelectPieceName = payload;
        },

        selectSession(state, payload) {
            const index = state.selectedSessions.indexOf(payload.sessionId);
            if (payload.event && index === -1) {
                state.selectedSessions.push(payload.sessionId);
            } else if (!payload.event && index !== -1) {
                state.selectedSessions.splice(index, 1);
            }
        },

        setDistance(state, payload) {
            state.filter.distanceId = payload;
        },

        setTime(state, payload) {
            state.filter.timesId = payload;
        },

        setErgoType(state, payload) {
            state.filter.byErgoId = payload;
        },

        setHrIntensity(state, payload) {
            state.filter.hrIntensities = payload;
        },

        setFocus(state, payload) {
            state.filter.focuses = payload;
        }
    }
};

export default profileReportsErgo;
